import React from 'react';
import Loading from './Loading';
import Table from './Table';
import { useConfirm } from './ConfirmContext';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

const AutomationResults = ({entries}) => {
  const confirm = useConfirm();
  const [range, setRange] = React.useState([new Date(Date.now() - 2*24*60*60*1000), new Date()]);

  const formatDate = (date) => {
    const day = date.getDate();
    const year = date.getFullYear();
    const monthNames = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];
    const month = monthNames[date.getMonth()];
    return `${day}_${month}_${year}`;
  }

  const handleDownload = async () => {
    let entries = getEntries();

    if (entries.length === 0) {
      const confirmed = await confirm('No data to download.', true);
      return;
    }

    let result = 'Date,Reason,Term,User Agent\n';

    for (let entry of entries) {
      let [date, reason, term, userAgent] = entry;

      reason = reason.replace(/"/g, '""');
      reason = reason.replace(/,/g, ' ');

      term = term.replace(/"/g, '""');
      term = term.replace(/,/g, ' ');

      userAgent = userAgent.replace(/"/g, '""');
      userAgent = userAgent.replace(/,/g, ' ');

      let row = [date, reason, term, userAgent];
      result += row.join(',') + '\n';
    }

    const url = window.URL.createObjectURL(
      new Blob([result], { type: 'text/csv' })
    );
    const a = document.createElement('a');
    a.href = url;
    let filename = 'automation_data_' + formatDate(new Date()) + '.csv';

    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();

    const confirmed = await confirm(`Saved data to file ${filename}.`, true);
  };

  const getDate = (created_at) => {
    const d = new Date(created_at);

    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    const yyyy = d.getFullYear();

    return `${mm}/${dd}/${yyyy}`;
  }

  const getEntries = () => {
    let [startDate, endDate] = range;

    if (!startDate || !endDate) return [];

    startDate.setHours(0, 0, 0, 0);
    endDate.setHours(23, 59, 59, 999);

    return entries
      .filter(entry => {
        const entryDate = new Date(entry.created_at);
        entryDate.setHours(0, 0, 0, 0);
        return entryDate >= startDate && entryDate <= endDate;
      })
      .map(({ created_at, reason, utm_term, data }) => {
        return [getDate(created_at),
                reason || '',
                utm_term || '',
                data?.ua || ''];
      })
  }

  if (entries === null) return <Loading />;

  return (
    <div style={{width: 'calc(100% - 40px)',
                 overflowY: 'auto',
                 padding: '20px',
                 display: 'flex',
                 flexDirection: 'column',
                 gap: '20px',
                }}>

      {entries.length > 0 && (
        <div style={{width: '100%',
                     display: 'flex',
                     backgroundColor: '#333',
                     padding: '10px 20px',
                     boxSizing: 'border-box',
                     flexDirection: 'row',
                     alignItems: 'center',
                     justifyContent: 'space-between',
                    }}>
          <DatePicker
            selectsRange={true}
            startDate={range[0]}
            endDate={range[1]}
            onChange={dates => setRange(dates)}
            isClearable={false}
            calendarClassName="dark-datepicker"
            popperClassName="dark-datepicker-popper"
            className="dark-datepicker-input"
          />
          <div className="simple-row"
               style={{cursor: 'pointer'}}
               onClick={() => handleDownload()} >
            Download data (csv)
          </div>
        </div>
      )}
      <Table headers={['Date', 'Reason', 'Term', 'User Agent']}
             contents={getEntries()}
             proportions={[1, 1, 1, 1]} />
    </div>
  );
}

export default AutomationResults;
